import ReactDOM from 'react-dom/client'
import './config/i18n'
import * as Sentry from '@sentry/react'
import App from './App'
import configureStore from './redux/store'
import { registerSW } from 'virtual:pwa-register'

const store = configureStore()
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

registerSW({ immediate: true })

if (import.meta.env.MODE === 'production') {
  Sentry.init({
    dsn: 'https://6f0a4f51ebe74abd9a01008173625248@o4504977750294528.ingest.sentry.io/4504987056013312',
    environment: import.meta.env.MODE,
    release: process.env.npm_package_version!,
    tracesSampleRate: 0.25,
    integrations: [Sentry.replayIntegration()],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1
  })
}

root.render(<App store={store} />)
